import React from "react";
import { Modal, ErrorMessage } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import { translatedModalProps } from "./helpers";

const TranslatedEditModal = (editModalProps) => {
    const { t } = useTranslation("shared");        
    const modalProps = translatedModalProps(editModalProps, t);    
    return (        
        <Modal.Edit  {...modalProps}
            header={modalProps.header ?? t("modals.edit.header")}
            submitLabel={modalProps.submitLabel ?? t("modals.edit.submitLabel")}
            cancelLabel={modalProps.cancelLabel ?? t("modals.edit.cancelLabel")}>
              <React.Fragment>
                {editModalProps.content ?? editModalProps.children}
                <ErrorMessage
                  header={editModalProps.error?.status == 500 ?  t("modals.errorHeader") : t("modals.somethingWentWrong")}
                  error={editModalProps.error}
                  omitCodes                    
                />
            </React.Fragment>
        </Modal.Edit>        
    )
}

export default TranslatedEditModal;
